/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetMyOrganizationsQueryResponse, GetMyOrganizations400, GetMyOrganizations401, GetMyOrganizations403, GetMyOrganizations404, GetMyOrganizations409, GetMyOrganizations500 } from "../../types/organizationController/GetMyOrganizations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetMyOrganizationsUrl() {
  const res = { method: 'GET', url: `/api/organizations/me` as const }
  return res
}

/**
 * @summary Get current user organizations
 * {@link /api/organizations/me}
 */
export async function getMyOrganizations(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMyOrganizationsQueryResponse, ResponseErrorConfig<GetMyOrganizations400 | GetMyOrganizations401 | GetMyOrganizations403 | GetMyOrganizations404 | GetMyOrganizations409 | GetMyOrganizations500>, unknown>({ method : "GET", url : getGetMyOrganizationsUrl().url.toString(), ... requestConfig })
  return res.data
}